<div class="k-overlay" *ngIf="content"></div>
<div class="argus-sidebar" *ngIf="content">
  <div>
    <svg-icon src='./assets/icons/close-outline.svg'
              class="svg-icon-large argus-sidebar-close-icon" (click)="cancel()" title="{{ 'exportToArgusConfirmDialog.close' | translate | uppercase }}"></svg-icon>
  </div>
  <div class="argus-sidebar-title">
    {{ translationKeyTitle | translate }}
  </div>
  <div class="argus-sidebar-content" [innerHTML]="content"></div>
  <div class="argus-sidebar-content" *ngIf="syncOption == ArgusSyncOptionEnum.CopyOfExistingValuation">
    <label class="d-block pb-15">{{ 'exportToArgusConfirmDialog.copyFromLabel' | translate }} </label>
    <kendo-dropdownlist class="w-100" [data]="argusValuations" [(ngModel)]="selectedArgusValuation" [valuePrimitive]="true" [textField]="'Name'" [valueField]="'WFPortfolioId'" (valueChange)="handleValueChange($event)">
    </kendo-dropdownlist>
  </div>
  <div class="argus-sidebar-footer-button">
    <button kendoButton class="button-continue" (click)="confirm()" *ngIf="!showClose" [disabled]="!selectedArgusValuation && syncOption == ArgusSyncOptionEnum.CopyOfExistingValuation">
      {{ 'exportToArgusConfirmDialog.confirm' | translate }}
    </button>    
  </div>
</div>
